__turbopack_context__.v({
  "hasCaption": "SubNav-module__bVWhVW__hasCaption",
  "showAll": "SubNav-module__bVWhVW__showAll",
  "subNav": "SubNav-module__bVWhVW__subNav",
  "subNavGroup": "SubNav-module__bVWhVW__subNavGroup",
  "subNavItem": "SubNav-module__bVWhVW__subNavItem",
});
